/* globals $ App */

export default class GetInTouch {
  constructor($elem) {
    this.$elem = $elem;
    this.$elem.find(".category-link").click((e) => {
      e.preventDefault();
      this.changeSelectCategory($(e.currentTarget).data("id"));
    });
    this.$elem.find("[name=category]").change((e) => {
      this.changeSideCategory($(e.target).val());
    });
    this.changeSideCategory(this.$elem.find("[name=category]").val());
    this.$elem.find("form")[0].addEventListener("freeform-ajax-after-submit", () => {
      App.getForms().then(() => {
        App.forms.initSelects(this.$elem.find("form select"));
      });
    });
  }

  changeSelectCategory(id) {
    this.$elem.find("[name=category]").multipleSelect("setSelects", [id]);
  }

  changeSideCategory(id) {
    let $cat = this.$elem.find(".category-link.active");
    $cat.removeClass("bg-white border-red-500 active").addClass("border-white");
    $cat = this.$elem.find(".category-link[data-id=" + id + "]");
    $cat.addClass("bg-white border-red-500 active").removeClass("border-white");
  }
}
